exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{padding:0;margin:0}.scratchCard{position:relative;border-radius:.1rem}.scratchCard .result{position:absolute;width:calc(100% - 4px);height:calc(100% - 2px);top:0;left:0;right:0;bottom:0;margin:auto}.scratchCard .pic{width:calc(100% - 2px);height:calc(100% - 2px)}.scratchCard canvas{position:relative;z-index:2;position:absolute;top:0;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57e57088","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/myPlugin/scratchCard/scratchCard.vue
// module id = 4
// module chunks = 0